import { useCallback, useContext } from "react";
import DropCtx from "../../context";
import Modal from "skin/entry/cmp/modal";
import useModal from "skin/entry/hook/modal";

export default function Mb({ children, title }) {
	const { setOpen } = useContext(DropCtx);
	const {show, close, ref} = useModal(true);
	const onClose = useCallback(() => {
		setOpen(false);
		close();
	}, [])
	if (!show) return null;
	return <Modal onClose={onClose} ref={ref} showClose>{children}</Modal>
}